import React, { useState } from 'react';
import styles from './styles.module.scss';

import Text from '../../Input/Text';
import { numberChars } from '../../../utils/format/character_restriction';

const Referral = ({
  text,
  button,
  spanish,
  onChange,
  onValidateReferral,
  hasValidatedReferal,
  isReferalValid,
  referralName,
  referralIdShow,
}) => {
  const [showForm, setForm] = useState(false);
  const toggle = () => setForm(!showForm);
  return (
    <div className={styles.container}>
      {!referralName ? (
        <div className={styles.toggle}>
          <button type="button" onClick={toggle}>
            {text}
          </button>
        </div>
      ) : null}
      {showForm || referralName ? (
        <form className={styles.form} onSubmit={onValidateReferral}>
          {!referralName ? (
            <Text
              type="text"
              placeholder={spanish ? 'Ingresa tu código' : 'Enter your code'}
              error={undefined}
              onChange={onChange}
              onKeyPress={numberChars}
              value={referralIdShow}
              maxLength={15}
            />
          ) : null}
          {hasValidatedReferal || referralName ? (
            <div className={styles.validation}>
              {isReferalValid ? (
                <p>
                  {spanish
                    ? `Nombre de FBO: ${referralName}`
                    : `FBO name is: ${referralName}`}
                </p>
              ) : (
                <p className={styles.error}>
                  {spanish
                    ? 'El código FBO ingresado es inválido, por favor verifícalo e intenta de nuevo'
                    : 'The FBO code you entered is invalid, please verify and try again'}
                </p>
              )}
            </div>
          ) : null}
          {!referralName ? (
            <button type="submit" className="btn btn-white">
              {button}
            </button>
          ) : null}
        </form>
      ) : (
        ''
      )}
    </div>
  );
};

export const FBO = ({ spanish, referralId, referralName }) => (
  <div className={styles.fbo}>
    <b>{spanish ? 'Nombre del FBO:' : 'FBO Name:'}</b>
    <p>{referralName}</p>
    <b>FBO ID</b>
    <p>{referralId}</p>
  </div>
);

export default Referral;
